interface NobuUIFeature<T = any> {
    id: string;
    type: NobuUIFeatureType;
    value: T;
}

type NobuUIFeatureType = 'custom' | 'component' | 'instance';

const currentPageTypeId: string = document.body.id || 'default';
const nobuUIRegisteredFeatures: NobuUIFeature[] = [];

document.addEventListener('DOMContentLoaded', () => {

});

const addFeature = <T>(
    id: string,
    type: NobuUIFeatureType,
    value: T
) => {
    if (featureExists(id)) {
        throw 'Cannot set two features with the same Id.'
    }

    nobuUIRegisteredFeatures.push({
        id, type, value
    });

    return NobuUIService;
};

const featureExists = (id: string): boolean => {
    for (let i = 0; i < nobuUIRegisteredFeatures.length; i++) {
        if (nobuUIRegisteredFeatures[i].id === id) {
            return true;
        }
    }

    return false;
};

const getFeatureById = <T>(
    id: string
) => {
    for (let i = 0; i < nobuUIRegisteredFeatures.length; i++) {
        if (nobuUIRegisteredFeatures[i].id === id) {
            return nobuUIRegisteredFeatures[i].value as T;
        }
    }

    return null;
};

const getFeaturesByType = <T>(
    type: NobuUIFeatureType
) => nobuUIRegisteredFeatures
    .filter(nobuUIRegisteredFeature => nobuUIRegisteredFeature.type === type)
    .map(nobuUIRegisteredFeature => nobuUIRegisteredFeature.value) as T[];

const onPage = (
    pageTypeId: string | string[],
    callbackFunction: () => void
) => {
    let validationSuccess: boolean = false;

    if (Array.isArray(pageTypeId)) {
        for (let i = 0; i < pageTypeId.length; i++) {
            if (currentPageTypeId === pageTypeId[i]) {
                validationSuccess = true;
                break;
            }
        }
    }
    else {
        validationSuccess = currentPageTypeId === pageTypeId;
    }

    if (validationSuccess) {
        callbackFunction();
    }

    return NobuUIService;
};

const onPageExcept = (
    pageTypeId: string | string[],
    callbackFunction: () => void
) => {
    let validationSuccess: boolean = true;

    if (Array.isArray(pageTypeId)) {
        for (let i = 0; i < pageTypeId.length; i++) {
            if (currentPageTypeId === pageTypeId[i]) {
                validationSuccess = false;
                break;
            }
        }
    }
    else {
        validationSuccess = currentPageTypeId !== pageTypeId;
    }

    if (validationSuccess) {
        callbackFunction();
    }

    return NobuUIService;
};

const NobuUIService = {
    addFeature,
    featureExists,
    getFeatureById,
    getFeaturesByType,
    onPage,
    onPageExcept
};

export default NobuUIService;
